module.exports = __webpack_public_path__ + "webfonts/lg.svg";


//////////////////
// WEBPACK FOOTER
// ../~/lightgallery/src/fonts/lg.svg?n1z373
// module id = 519
// module chunks = 64 65